import React, { Component } from 'react';
import { Chart } from "react-google-charts";
import { connect } from 'react-redux'
import domtoimage from 'dom-to-image';
import { Button } from 'react-materialize'

class LineChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      line_data: [[]]
    };
  }

  componentDidMount(){
    var line_data = this.convertData();
    this.setState({ line_data: line_data})
  }

  yearsBetweenTwo(year1, year2){
    var years = [year1];
    for ( let i = year1+1; i <= year2; i++ ){
      years.push(i);
    }
    return years
  }

  mapDataWithKeys( data, gender, countries, age, yearBound){
    var data_map = {};
    var years = this.yearsBetweenTwo(yearBound[0],yearBound[1]);
    years.forEach ( year =>
      {
        data_map[year] = {}
        countries.forEach( country => {
          gender.forEach ( gender => {
            age.forEach( age => {
              data_map[year][`${gender}/${age}/${country}`] = null;
            })
          })
        })
      });


    data.forEach( document => {
       if(document.sample_year >= yearBound[0] && document.sample_year <= yearBound[1]){
         //one gender one age
         if(gender.length === 1 && age.length === 1 ){
           countries.forEach( country => {
             if(document.country === country && document.gender === gender[0] && document.age === age[0]){
               data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
             }
           })
         } else if (gender.length === 2 && age.length === 1){ //two genders 1 age
           countries.forEach( country => {
             if(document.country === country && document.gender === gender[0] && document.age === age[0]){
               data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
             } else if (document.country === country && document.gender === gender[1] && document.age === age[0]){
               data_map[document.sample_year][`${gender[1]}/${age[0]}/${country}`] = document.value;
             }
           })
         } else if (gender.length === 1 && age.length === 2){ //1 gender 2 age
           countries.forEach( country => {
             if(document.country === country && document.gender === gender[0] && document.age === age[0]){
               data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
             } else if (document.country === country && document.gender === gender[0] && document.age === age[1]){
               data_map[document.sample_year][`${gender[0]}/${age[1]}/${country}`] = document.value;
             }
           })
         } else if (gender.length === 2 && age.length === 2){
           countries.forEach( country => {
             if(document.country === country && document.gender === gender[0] && document.age === age[0]){
               data_map[document.sample_year][`${gender[0]}/${age[0]}/${country}`] = document.value;
             } else if (document.country === country && document.gender === gender[0] && document.age === age[1]){
               data_map[document.sample_year][`${gender[0]}/${age[1]}/${country}`] = document.value;
             } else if (document.country === country && document.gender === gender[1] && document.age === age[0]){
               data_map[document.sample_year][`${gender[1]}/${age[0]}/${country}`] = document.value;
             } else if (document.country === country && document.gender === gender[1] && document.age === age[1]){
               data_map[document.sample_year][`${gender[1]}/${age[1]}/${country}`] = document.value;
             }
           })
         }
       }
    })
    return data_map;
   }

  convertData(){
    const { data, gender, yearBound, countries, sortedAgeByData } = this.props;
    var line_data = [];
    var header = ["Year"];
    // var countries_display = [];
    //
    // if(countries.length <= 10){
    //   countries_display = countries;
    // } else {
    //   countries_display = countries.slice(0, 10);
    // }
    if(countries.length <= 10 ){
      var data_map = this.mapDataWithKeys(data, gender, countries, sortedAgeByData, yearBound);
      gender.forEach( gender => {
        sortedAgeByData.forEach (age => {
          countries.forEach( country => {
            header.push( `${gender}/${age}/${country}` )
          })
        })
      })

      line_data.push(header);
      for (var key in data_map){
        var temp_arr = [];
        temp_arr.push(key);
        for(let i = 1; i < header.length; i++){
            temp_arr.push(data_map[key][header[i]])
        }
        line_data.push(temp_arr);
      }


      if( line_data.length >= 3){
        var null_index = [];
        line_data[1].forEach((data, index) => {
          if(data === null){
            null_index.push(index)
          }
        });

        for(let i = 2; i < line_data.length; i++){
          for(let j = null_index.length - 1; j >= 0; j--){
            if(line_data[i][null_index[j]] !== null){
              null_index.splice(j, 1);
            }
          }
        }
        if(null_index.length !== 0){
          for(let i = null_index.length-1; i >= 0; i --){
            for(let j = 0; j < line_data.length; j ++){
              line_data[j].splice(null_index[i], 1)
            }
          }
        }
      }
    }

    return line_data

    // const dummy_data = [
    //   ["Year", "Male/15/Canada", "Male/15/United States"],
    //   ["2004", 10, 11],
    //   ["2005", 20, 15],
    //   ["2006", 13, 18],
    //   ["2007", 15, 22]
    // ];

  }

  RenderPicture(){
    var node = document.getElementById('line-chart');
    domtoimage.toJpeg(node, { bgcolor: "white", height: 600, width: 1100 })
     .then(function (dataUrl) {
         console.log(dataUrl);
         var link = document.createElement('a');
         link.download = 'bar_chart.jpeg';
         link.href = dataUrl;
         link.click();
     });
  }

  render() {

    const options = {
      curveType: "none",
      pointSize: 5,
      legend: { position: "bottom",
                maxLines: '4',
                fontSize: '9px'},
      colors: ['#28bfa0', '#974bc7', '#5c1380', '#68d3df', '#d1006e',
               '#f1ab01','#003864', '#c5d700', '#830050', '#ef523d'],
      interpolateNulls: true,
      chartArea: {width: '90%', height: '90%'},
    };

    const { line_data } = this.state;
    const { countries, age, gender } = this.props;

  return (
    <div>
      <div id="line-chart">
      {
        line_data.length > 0? (
          line_data[0].length > 1?
        <div>
          {/* {
            countries.length > 6 || age.length > 2 || gender.length > 2?
            <div>Display limits: 2 age categories, 10 countries</div>
            : ""
          } */}
          <div>
            <Chart
            chartType="LineChart"
            width="100%"
            height="600px"
            data={line_data}
            options={options}/>
            <div className="pulled-right">
              <Button onClick={()=>{this.RenderPicture()}}>DOWNLOAD JPG</Button>
            </div>
          </div>
        </div>:<div></div>):<div></div>
      }
    </div>
  </div>

  )}
}

function mapStateToProps(state){
  return {
    data: state.data,
    gender: state.gender,
    yearBound: state.yearBound,
    countries: state.countries,
    age: state.age,
    sortedAgeByData: state.sortedAgeByData
    }
};


export default connect(mapStateToProps)(LineChart);



// WEBPACK FOOTER //
// ./src/components/LineChart.js